import script from "./DynamicSvg.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicSvg.vue?vue&type=script&setup=true&lang=ts"

import "./DynamicSvg.vue?vue&type=style&index=0&id=214d5160&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-214d5160"]])

export default __exports__